export default "__VITE_ASSET__c416f29c__"